// import { X } from "lucide-react";

// const CustomFilterDropdown = ({
//     data = [],
//     placeholder = "Search...",
//     selectedKeys,
//     setSelectedKeys,
//     confirm,
//     clearFilters,
// }) => {

//     // Search text (only first element is search)
//     const searchText = selectedKeys[0] || "";

//     // For selections, remove search text element
//     const selectedValues = selectedKeys.slice(1);

//     const toggleItem = (item) => {
//         let updated;

//         if (selectedValues.includes(item)) {
//             updated = selectedValues.filter(v => v !== item);
//         } else {
//             updated = [...selectedValues, item];
//         }

//         setSelectedKeys([searchText, ...updated]);

//         confirm();
//     };


//     const handleSelectAll = () => {
//         setSelectedKeys([searchText, ...data]);
//         confirm();
//     };

//     const handleClearAll = () => {
//         setSelectedKeys([searchText]);
//         clearFilters();
//         confirm();
//     };


//     const isAnySelected = selectedValues.length > 0;

//     return (
//         <div className="custom-popup">

//             <div className="popup-header">
//                 <span className="popup-close" onClick={() => confirm()}>
//                     <X size={16} />
//                 </span>
//                 {!isAnySelected && (
//                     <button className="popup-select-all" onClick={handleSelectAll}>
//                         Select All
//                     </button>
//                 )}

//                 {isAnySelected && (
//                     <button className="popup-clear-all" onClick={handleClearAll}>
//                         Clear All
//                     </button>
//                 )}


//             </div>

//             <div className="popup-search-box">
//                 <input
//                     type="text"
//                     placeholder={placeholder}
//                     className="popup-search-input"
//                     value={searchText}
//                     onChange={(e) => setSelectedKeys([e.target.value, ...selectedValues])}
//                 />
//             </div>
//             <div className="popup-list">
//                 {data
//                     .filter(item =>
//                         !searchText || item.toLowerCase().includes(searchText.toLowerCase())
//                     )
//                     .map(item => {
//                         const isChecked = selectedValues.includes(item);

//                         return (
//                             <div
//                                 key={item}
//                                 className="popup-item"
//                                 onClick={() => toggleItem(item)}
//                             >
//                                 <span>{item}</span>

//                                 <span className={`popup-check ${isChecked ? "checked" : ""}`}>
//                                     {isChecked && (
//                                         <svg
//                                             width="12"
//                                             height="12"
//                                             viewBox="0 0 24 24"
//                                             fill="none"
//                                             stroke="#ff4d4f"
//                                             strokeWidth="3"
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                         >
//                                             <polyline points="20 6 9 17 4 12" />
//                                         </svg>
//                                     )}
//                                 </span>
//                             </div>
//                         );
//                     })}
//             </div>

//         </div>
//     );
// };

// export default CustomFilterDropdown;


import { X } from "lucide-react";
import { useState } from "react";
import { translations } from "../../utils/constants";

const CustomFilterDropdown = ({
    data = [],
    placeholder = "Search...",
    selectedKeys,
    setSelectedKeys,
    confirm,
    clearFilters,
    noDataText,
    language
}) => {

    // Keep search text local so it never leaks into the actual filter values.
    const [searchText, setSearchText] = useState("");

    // selectedKeys contains only the actual selected filter values.
    const selectedValues = selectedKeys || [];

    // --- Translation Logic ---
    const t = translations?.[language] || translations["en"];
    const isIt = language === 'it';

    // Auto-generate message if not provided (Handled for Italian/English)
    const emptyMessage =
        noDataText ||
        (isIt
            ? `Nessun ${placeholder.replace("Cerca", "").replace("...", "").trim()} trovato`
            : `No ${placeholder.replace("Search", "").replace("...", "").trim()} found`);

    const getLabel = (item) => {
        return typeof item === "object" ? item.label : item;
    };

    const getValue = (item) => {
        return typeof item === "object" ? item.value : item;
    };

    const filteredData = data.filter(item =>
        !searchText ||
        getLabel(item).toLowerCase().includes(searchText.toLowerCase())
    );

    const toggleItem = (item) => {
        const value = getValue(item);
        let updated;

        if (selectedValues.includes(value)) {
            updated = selectedValues.filter(v => v !== value);
        } else {
            updated = [...selectedValues, value];
        }

        setSelectedKeys(updated);
        confirm();
    };

    const handleSelectAll = () => {
        const allValues = data.map(getValue);
        setSelectedKeys(allValues);
        confirm();
    };

    const handleClearAll = () => {
        setSelectedKeys([]);
        clearFilters();
        confirm();
    };

    const isAnySelected = selectedValues.length > 0;

    return (
        <div className="custom-popup">
            <div className="popup-header">
                <span className="popup-close" onClick={() => confirm()}>
                    <X size={16} />
                </span>

                {!isAnySelected ? (
                    <button className="popup-select-all" onClick={handleSelectAll}>
                        {t?.selectAll || "Select All"}
                    </button>
                ) : (
                    <button className="popup-clear-all" onClick={handleClearAll}>
                        {t?.clearAll || "Clear All"}
                    </button>
                )}
            </div>

            <div className="popup-search-box">
                <input
                    type="text"
                    placeholder={placeholder}
                    className="popup-search-input"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>

            <div className="popup-list">
                {filteredData
                    .map(item => {
                        const label = getLabel(item);
                        const value = getValue(item);
                        const isChecked = selectedValues.includes(value);

                        return (
                            <div
                                key={value}
                                className="popup-item"
                                onClick={() => toggleItem(item)}
                            >
                                <span className={`popup-check ${isChecked ? "checked" : ""}`}>
                                    {isChecked && (
                                        <svg
                                            width="12"
                                            height="12"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#ff4d4f"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    )}
                                </span>
                                <span>{label}</span>
                            </div>
                        );
                    })}
                {filteredData.length === 0 && (
                    <div className="no-data">{emptyMessage}</div>
                )}
            </div>
        </div>
    );
};

export default CustomFilterDropdown;